module.exports = __webpack_public_path__ + "static/yatrapic-3f34ad83d7362aafc9c07c189af8d90e.png";